import {Inject, NgModule, PLATFORM_ID} from '@angular/core';

import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {isPlatformBrowser, registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import {environment} from '@env';
import {ServiceWorkerModule, SwRegistrationOptions} from '@angular/service-worker';

import {AppUpdateService} from '@app/service/app-update/app.update.service';
import {WindowRef} from '@app/window-ref';
import {AppModule} from './app.module';
// import {getMessaging, provideMessaging} from '@angular/fire/messaging';
import {getPerformance, providePerformance} from '@angular/fire/performance';
import {connectAuthEmulator, provideAuth} from '@angular/fire/auth';
import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  indexedDBLocalPersistence,
  initializeAuth
} from 'firebase/auth';
import {getApp} from '@angular/fire/app';
import {
  connectFirestoreEmulator,
  enableMultiTabIndexedDbPersistence,
  initializeFirestore, CACHE_SIZE_UNLIMITED,
  provideFirestore
} from '@angular/fire/firestore';

registerLocaleData(en);

@NgModule({
  imports: [
    AppModule,
    BrowserAnimationsModule,

    provideAuth(() => {
      const auth = initializeAuth(getApp(), {
        persistence: [indexedDBLocalPersistence, browserLocalPersistence],
        popupRedirectResolver: browserPopupRedirectResolver
      });
      if (environment.useEmulators) {
        connectAuthEmulator(auth, 'http://localhost:9099', {disableWarnings: true});
      }
      return auth;
    }),
    provideFirestore(() => {
      const firestore = initializeFirestore(getApp(), {
        // localCache: persistentLocalCache({tabManager: persistentMultipleTabManager()}),
        cacheSizeBytes: CACHE_SIZE_UNLIMITED
      });
      // const firestore = getFirestore();
      if (environment.useEmulators) {
        connectFirestoreEmulator(firestore, 'localhost', 8081);
      }
      enableMultiTabIndexedDbPersistence(firestore)
        .catch((err) => {
          console.log('enableIndexedDbPersistence', err);
        });
      return firestore;
    }),
    // provideMessaging(() => getMessaging()),
    providePerformance(() => getPerformance()),

    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !environment.local,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    {
      provide: SwRegistrationOptions,
      useFactory: (platform: any) => ({
        enabled: isPlatformBrowser(platform) && location.host.includes('carvry')
      }),
      deps: [PLATFORM_ID]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppBrowserModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private windowRef: WindowRef,
    private updateService: AppUpdateService) {
  }
}
